/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:37:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:09:52                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * CustomerDashCard - Display customer
*/

/* Imports */
import { BuildingOfficeIcon, EnvelopeIcon, MapPinIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
import { t } from "i18next";
/***/

/* Components */
import AddressDisplay from "../address/AddressDisplay";
/***/

/* Styles */
import "./CustomerDashCard.scss";
import CustomerDisplay from "../customer/CustomerDisplay";
/***/

/**
* CustomerDashCard - Display customer
* @param customer - customer data
* @param onClick - on click event, trigger on component click
*/
export default function CustomerDashCard({
  customer,
  onClick
}: {
  customer: EasyTech.Customer,
  onClick?: () => void
}) {
  return (
  <div className="customer-card" onClick={() => onClick && onClick()}>
    <div className="icon-text-container">
      <div className="icon-text">
        <BuildingOfficeIcon className="w-5" />
        <CustomerDisplay customer={customer} />
      </div>
      {customer.address && (
        <div className="icon-text">
          <MapPinIcon className="w-5" />
          <AddressDisplay address={customer.address} />
        </div>
      )}
    </div>

    <div className="icon-text-container">
      <div className="icon-text">
        <EnvelopeIcon className="h-[20px] w-[20px] text-gray-400"/>
        <Typography>
          {customer.contactInfo && customer.contactInfo.email ? customer.contactInfo.email : t("common:noEmail")}
        </Typography>
      </div>
      
      <div className="icon-text">
        <PhoneIcon className="h-[20px] w-[20px] text-gray-400"/>
        <Typography>
          {customer.contactInfo && customer.contactInfo.phone ?  customer.contactInfo.phone : t("common:noPhone")}
        </Typography>
      </div>
    </div>
  </div>
  );
}
/***/
